import { render } from "./VFXGrid.vue?vue&type=template&id=4e62c517"
import script from "./VFXGrid.vue?vue&type=script&lang=js"
export * from "./VFXGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__